import { render } from "./OperativeDashboard.vue?vue&type=template&id=6250455e&scoped=true"
import script from "./OperativeDashboard.vue?vue&type=script&lang=js"
export * from "./OperativeDashboard.vue?vue&type=script&lang=js"

import "./OperativeDashboard.vue?vue&type=style&index=0&id=6250455e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6250455e"]])

export default __exports__